import CareConciergContactForm from '@/features/provider-directory/components/CareConciergContactForm';

type MatchmakingNoResultsStateProps = Record<string, never>;

export const MatchmakingNoResultsState = ({}: MatchmakingNoResultsStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-8 px-4">
      <div className="max-w-4xl w-full space-y-8">
        {/* No Results Messaging */}
        <div className="space-y-2 text-center">
          <h3 className="text-2xl md:text-3xl font-recoleta font-semibold text-[#111827] mb-2">
            We're still searching for the right fit
          </h3>
          <p className="text-base font-termina text-[#6B7280] max-w-3xl mx-auto">
            While there are no providers that match your exact search criteria at this time, our network is continually growing. You may wish to refine your search or add more detail so we can better tailor the results for you.
          </p>
        </div>

        {/* Care Concierge Form */}
        <CareConciergContactForm
          sourceContext="navigator"
          pageOrigin="provider-directory-no-results"
        />
      </div>
    </div>
  );
};

